module.exports = __webpack_public_path__ + "js/components/Desktop/images/githubIcon-13512a73afeb750c5f20ac49d20f6a5b.png";